export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/flag-germany.b4198523.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};